export default function PageTitle({ children }: any) {
  return (
    <h1 className="text-[40px] md:text-6xl mb-10 text-blue-one m-0 font-bold">
      {children}
    </h1>
  );
}
